import { Component } from 'react'
import styled from 'glamorous'
import { withRouter } from 'react-router-dom'
import Route from 'react-router-dom/Route'
import Redirect from 'react-router-dom/Redirect'
import Switch from 'react-router-dom/Switch'
import { graphql, compose } from 'react-apollo'
import filter from 'lodash/filter'
import range from 'lodash/range'

import { $, getLocationQuery, getUrlSearch, getError } from 'utils'
import { Button, InnerLayout, PaginationBar, EmptyLayout, EmptyDetails, Loader } from 'components'
import { DESCRIPTOR_LISTS, PERSON_LISTS, CreateList } from 'queries'
import { withConsumer } from 'store'

import ListPages from './ListPages'
import DetailsPage from './DetailsPage'


const Header = styled.div({
  display: 'flex',
  justifyContent: 'space-between'
})

const HeaderButtons = styled.div({
  width: 380,
  display: 'flex'
})

const personTab = '/list/persons'
const faceTab = '/list/faces'

export const ListRoutes = () =>
  $(Switch,
    $(Route, {
      key: personTab,
      path: `${personTab}`,
      render: getComponent('persons')
    }),
    $(Route, {
      key: faceTab,
      path: `${faceTab}`,
      render: getComponent('descriptors')
    }),
    $(Redirect, { to: personTab })
  )

class Lists extends Component {

  changePage = (value) => {
    const { history, location, data: { variables: vars } } = this.props
    const search = getUrlSearch({...vars, offset: value})
    history.push({
      pathname: location.pathname,
      search,
    })
  }

  handleCreateList = (type) => () => {
    this.props.createList({
      variables: {
        listData: '',
        type,
      },
      // todo: temporary update of lists
      // TODO this needs refactoring
      update: (proxy, { data: { createList } }) => {
        const page = this.props.location.pathname.indexOf('persons') !== -1 ? 'persons' : 'descriptors'
        const query = type === 'persons' ? PERSON_LISTS : DESCRIPTOR_LISTS
        const typename = type === 'persons' ? 'PersonsListObject' : 'DescriptorsListObject'
        if (type === page) {
          const variables = getVariables(getLocationQuery(this.props.location))
          const data = proxy.readQuery({ query, variables })
          data[`${type}Lists`].items = [
            {uuid: createList.listId, listData: createList.listData, __typename: typename},
            ...data[`${type}Lists`].items
          ]
          data[`${type}Lists`].items = filter(data[`${type}Lists`].items, (item, i) => i < variables.limit)
          data[`${type}Lists`].count = data[`${type}Lists`].count + 1
          proxy.writeQuery({ query, data, variables })
        } else {
          try {
            const variables = getVariables()
            const data = proxy.readQuery({ query, variables })
            data[`${type}Lists`].items = [
              {uuid: createList.listId, listData: createList.listData, __typename: typename},
              ...data[`${type}Lists`].items
            ]
            data[`${type}Lists`].items = filter(data[`${type}Lists`].items, (item, i) => i < variables.limit)
            data[`${type}Lists`].count = data[`${type}Lists`].count + 1
            proxy.writeQuery({ query, data, variables })
          } catch(e) {
            return null
          }
        }
      }
    })
      .then(({ data }) => this.props.history.push({
        pathname: `/list/${type === 'persons' ? type : 'faces'}/${data.createList.listId}`,
        search: window.location.search
      }))
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  render = () => {
    const {
      data: { loading, variables: vars, personsLists, descriptorsLists }, match,
      checkData: { personsLists: checkPersonsLists, descriptorsLists: checkDescriptorsLists }
    } = this.props
    if (loading && !personsLists && !descriptorsLists) return $(Loader)
    const selectedTab = match.path.indexOf('persons') !== -1 ? 'persons' : 'faces'
    const lists = descriptorsLists || personsLists || {}
    const checkLists = checkDescriptorsLists || checkPersonsLists || {}
    const pagesCount = lists ? Math.ceil(lists.count / (vars.limit || 5)) : 0
    const paginationOptions = range(1, pagesCount + 1)

    return (
      (lists.count > 0 || checkLists.count > 0)
        ? $(InnerLayout,
            $(Header,
              $(PaginationBar, {
                name: 'Lists',
                options: paginationOptions,
                value: vars.offset || 1,
                onChange: this.changePage,
                from: pagesCount
              }),
              $(HeaderButtons,
                $(Button, {
                  onClick: this.handleCreateList('descriptors'),
                  bgColor: 'var(--violet)',
                  width: '100%',
                  style: {marginRight: 10}
                }, 'Add faces list'),
                $(Button, {
                  onClick: this.handleCreateList('persons'),
                  bgColor: 'var(--violet)',
                  width: '100%'
                }, 'Add persons list'),
              ),
            ),
            $(Switch,
              $(Route, {
                path: `/list/(persons|faces)/:id?`,
                render: () =>
                  $(ListPages, { lists: lists.items, selectedTab }),
              })
            ),
            $(Switch,
              $(Route, {
                path: `/list/persons/:id`,
                render: () => $(DetailsPage, { type: 'persons' })
              }),
              $(Route, {
                path: `/list/faces/:id`,
                render: () => $(DetailsPage, { type: 'faces' })
              }),
              $(Route, {
                path: `/list/faces`,
                component: EmptyDetails
              }),
              $(Route, {
                path: `/list/persons`,
                component: EmptyDetails
              }),
            )
          )
        : $(EmptyLayout, {
            title: 'There are no lists yet',
            icon: 'listsEmpty',
            loading
          },
            $(HeaderButtons,
              $(Button, {
                onClick: this.handleCreateList('descriptors'),
                primary: true,
                bgColor: 'var(--violet)',
                width: 124,
                height: 34,
                style: {marginRight: 8}
              }, 'Add faces list'),
              $(Button, {
                onClick: this.handleCreateList('persons'),
                primary: true,
                bgColor: 'var(--violet)',
                width: 124,
                height: 34
              }, 'Add persons list'),
            ),
          )
    )
  }
}

const getComponent = (type) => withRouter(
  compose(
    graphql(CreateList, { name: 'createList' }),
    graphql(type === 'persons' ? PERSON_LISTS : DESCRIPTOR_LISTS, {
      options: props => {
        const queryParams = getLocationQuery(props.location)
        return {
          fetchPolicy: 'cache-and-network',
          variables: getVariables(queryParams)
        }
      }
    }),
    graphql(type === 'persons' ? DESCRIPTOR_LISTS : PERSON_LISTS, {
      name: 'checkData',
      options: props => {
        return {
          fetchPolicy: 'cache-and-network',
          variables: getVariables()
        }
      }
    })
  )(withConsumer(Lists)))

export const getVariables = (queryParams = {}) => ({
  limit: +queryParams.limit || 5,
  offset: +queryParams.offset || 1,
})



// WEBPACK FOOTER //
// ./src/pages/Lists/index.js